import { env } from "@/env";

export const SurveyDiscountBanner = () => {
  return (
    <div className="flex w-full items-center justify-center rounded-xl bg-accent px-6 py-3">
      <p className="text-center text-base font-medium text-accent-content">
        Use code <strong>{env.VITE_SURVEY_DISCOUNT_CODE}</strong> at checkout <br /> for an extra
        $10 off!
      </p>
    </div>
  );
};
